import React from "react";
import "./sccs/FormInfoCreateUpdate.scss";

const FormInfoCreateUpdate = ({
  isCreate,
  estadoFormulario,
  estadoFormularioDescripcion,
  fechaActualizacionEstado,
}) => {
  const formatStatusDate = (value) => {
    if (!value) return null;
    const parsedDate = new Date(value);
    if (Number.isNaN(parsedDate.getTime())) return null;

    return new Intl.DateTimeFormat("es-ES", {
      dateStyle: "medium",
      timeStyle: "short",
    }).format(parsedDate);
  };

  const formattedStatusDate = formatStatusDate(fechaActualizacionEstado);
  const statusDescription = estadoFormularioDescripcion || "Estado no disponible";

  return (
    <div
      className={`form-info-create-update ${
        isCreate ? "create" : "update"
      }`}
      data-estado-formulario={estadoFormulario ?? ""}
    >
      <div className="form-info-content">
        <span className="form-info-icon">
          <span
            className={`e-icons ${
              isCreate ? "e-circle-add" : "e-edit"
            }`}
          ></span>
        </span>

        <div className={`form-info-text ${!isCreate ? "with-status" : ""}`}>
          {!isCreate ? (
            <div className="form-info-layout">
              <div className="form-info-copy">
                <p className="form-info-title">Editando formulario</p>
                <p className="form-info-subtitle">Está modificando un formulario existente.</p>
              </div>

              <div className="form-info-meta">
                <div className="form-info-chip status-chip">
                  <span className="chip-label">Estado</span>
                  <span className="chip-value">{statusDescription}</span>
                </div>

                <div className={`form-info-chip date-chip ${!formattedStatusDate ? "is-empty" : ""}`}>
                  <span className="chip-label">Fecha estado</span>
                  <span className="chip-value">
                    {formattedStatusDate || "No se ha modificado el estado"}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <>
              <p className="form-info-title">Creando nuevo formulario</p>
              <p className="form-info-subtitle">
                Complete los datos para registrar un nuevo formulario.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormInfoCreateUpdate;